module.exports = __webpack_public_path__ + "img/term-5.61352cad.png";